import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  getConfig() {
    return axios.get(`${API_URL}/shipping/config`, { headers: authHeader() });
  },
  calculate(payload) {
    return axios.post(`${API_URL}/shipping/calculate`, payload, { headers: authHeader() });
  },
  generateWaybill(payload) {
    return axios.post(`${API_URL}/shipping/waybill`, payload, { headers: authHeader() });
  },
  getWaybillPdf(ids) {
    return axios.post(`${API_URL}/shipping/waybill-pdf`, { ids }, { headers: authHeader() });
  },
};
